import React, { useEffect } from "react";
import "./lizenzpartner.scss";
import LizenzImage from "../../../assets/images/lizenz.png";
import LizenzContentSection from "./lizenzContentSection";
import RightContent from "./rightContentStyle";
import Zeitersparnis from "./zeitersparnis";
import { NavLink } from "react-router-dom";
export default function Lizenzpartner() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <div className="lizenz-partner-first-section-alignment">
        <div className="grid">
          <div className="grid-items">
            <div className="text-grid animate__fadeInLeft animate__animated">
              <div className="text-grid-items">
                <div className="divider"></div>
              </div>
              <div className="text-grid-items">
                <h1>Lizenzpartner</h1>
              </div>
            </div>
            <p className="animate__slideInUp animate__animated wow">
              Die Lizenzpartnerschaft ist ist die Win-Win-Lösung für den
              Immobiliensektor - denn gemeinsam sind wir erfolgreicher.
            </p>
            <p className="animate__slideInUp animate__animated wow">
              Erhöhen Sie jetzt Ihren Erfolg bei weniger Kosten und Stress mit
              dieser Markenlizenz. Es entstehenden dabei keine zusätzlichen
              Verpflichtungen oder Kosten.
            </p>
            <div className="outline-primary-button">
              <NavLink to="/kontakt">
                <button>Kontakt aufnehmen</button>
              </NavLink>
            </div>
          </div>
          <div className="grid-items">
            <div className="image-style">
              <NavLink to="/kontakt">
                <img
                  className="animate__backInUp animate__animated wow"
                  src={LizenzImage}
                  alt="LizenzImage"
                />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <LizenzContentSection />
      <RightContent />
      <Zeitersparnis />
    </div>
  );
}
